// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--Pu5cb","heading":"_103a151b99--heading--Xgp4J","button":"_103a151b99--button--wP7fB"};